/**
 * Resource Library – archive page client-side filter
 */
document.addEventListener('DOMContentLoaded', () => {
  const authorSelect = document.getElementById('resource-filter-author');
  const programSelect = document.getElementById('resource-filter-program');
  const cards = document.querySelectorAll('.resource-card');
  const noResults = document.querySelector('.resource-no-results');

  if (!cards.length) return;

  // Initialise selects from URL query string on page load.
  const params = new URLSearchParams(window.location.search);
  if (authorSelect && params.has('author')) authorSelect.value = params.get('author');
  if (programSelect && params.has('program')) programSelect.value = params.get('program');

  function updateURL() {
    const p = new URLSearchParams();
    const authorVal = authorSelect ? authorSelect.value : '';
    const programVal = programSelect ? programSelect.value : '';

    if (authorVal && authorVal !== 'all') p.set('author', authorVal);
    if (programVal && programVal !== 'all') p.set('program', programVal);

    const qs = p.toString();
    history.replaceState(null, '', qs ? '?' + qs : window.location.pathname);
  }

  function filterCards() {
    const authorVal = authorSelect ? authorSelect.value : '';
    const programVal = programSelect ? programSelect.value : '';
    let visible = 0;

    cards.forEach(card => {
      const authors = card.dataset.author || '';
      const programs = card.dataset.program || '';

      const authorMatch = !authorVal || authorVal === 'all' || authors.split(/\s+/).includes(authorVal);
      const programMatch = !programVal || programVal === 'all' || programs.split(/\s+/).includes(programVal);

      const show = authorMatch && programMatch;
      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });

    if (noResults) {
      noResults.style.display = visible === 0 ? '' : 'none';
    }
  }

  function onFilterChange() {
    updateURL();
    filterCards();
  }

  if (authorSelect) authorSelect.addEventListener('change', onFilterChange);
  if (programSelect) programSelect.addEventListener('change', onFilterChange);

  // Apply filters on load (handles any pre-selected values from the URL).
  filterCards();
});
